/* When keyboard editing, a date element's "change" event acts more like "input" event.
 * This method installs handlers which track the typing state, making it more like other
 * "change" events.
 */

export const onDateChange = (input, callback) => {
  let typed = false;
  let lastValue = input.value;

  const fire = () => {
    // Only fire if value actually changed
    if (input.value === lastValue) {
      return;
    }

    typed = false;
    lastValue = input.value;
    callback();
  };

  /* Track keyboard interaction to distinguish from picker events. */
  input.addEventListener("keydown", () => {
    typed = true;
  });

  input.addEventListener("keyup", (ev) => {
    if (ev.key === "Enter") {
      fire();
    }
  });

  input.addEventListener("blur", () => {
    if (typed) {
      fire();
    }
  });

  input.addEventListener("change", () => {
    if (!typed) {
      /* This should only be in response to non-keyboard events,
       * like clicking a date in the picker (no keyboard interaction). */
      fire();
    }
  });
};
